import React from "react";

import { localization } from "./config/localization";
import { commander } from "./commander";
import { generateRoute } from "./helper-generate-route";
import { AppView } from "./view";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";

const LazyArticle = React.lazy(
    () => import(/* webpackPrefetch: true */ "../article"),
);
const LazyCommunity = React.lazy(() => import("../community"));
const LazyNews = React.lazy(() => import("../news"));
const LazyEsport = React.lazy(() => import("../esport"));

export const AppController = ({ sendCommand }) => {
    const { trackLinkClick } = useSnowplowContext();

    const routes = [
        generateRoute("/news/:id/:slug/:variant", LazyArticle),
        generateRoute("/news/:id/:slug", LazyArticle),
        generateRoute("/news/:id", LazyArticle),
        generateRoute("/esport/*", LazyEsport),
        generateRoute("/community", LazyCommunity),
        generateRoute("/news", LazyNews),
        generateRoute("/", LazyNews),
    ];

    const props = {
        routes,
        localization,
        commander: commander(sendCommand, trackLinkClick),
    };

    return <AppView {...props} />;
};
